/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class AssetsDirective {
    public restrict = 'E';
    public scope;
    public template;
    constructor(private Process: IProcessService, private bsLoadingOverlayService: IBsLoadingService) {
        this.restrict = 'E';
        this.template = `
            <table
                id="highlightElement22" style="text-align-last: center"
                class="table table-material md-custom-table br-normal">
                <thead>
                    <tr>
                        <th class="first_col sorted_by_this">Type</th>
                        <th class="d-none d-md-table-cell">Name</th>
                        <th class="d-none d-md-table-cell">Serial Number</th>
                        <th class="d-none d-md-table-cell">Created Date</th>
                        <th class="d-none d-md-table-cell" ng-if="C.User.hasPermission('org.change_org')">Return</th>
                        <th class="d-none d-md-table-cell" ng-if="C.User.hasPermission('org.change_org')">Assign To</th>
                        <th class="d-none d-md-table-cell">Audit Trail</th>
                        <th class="d-none d-md-table-cell" ng-if="C.User.hasPermission('org.change_org')">Edit</th>
                        <th class="d-none d-md-table-cell" ng-if="C.User.hasPermission('org.change_org')">Delete</th>
                        <th class="w-20" ng-if="C.assetTable(assetTable, 'org.change_org')">
                            <md-button class="md-icon-button md-primary" ng-click="C.addAsset({})">
                                <md-icon md-font-library="material-icons" class="p-0">add_circle</md-icon>
                            </md-button>
                        </th>
                    </tr>
                </thead>
                <tbody
                    ng-repeat="asset in typeArray track by $index">
                    <tr ng-if="typeArray.length > 0">
                        <td class="first_col sorted_by_this b-word">
                            {{ asset.assetType }}</td>
                        <td class="d-none d-md-table-cell">{{ asset.assetName }}</td>
                        <td class="d-none d-md-table-cell">{{ asset.assetSerialNumber }}</td>
                        <td class="d-none d-md-table-cell">{{ asset.assetCreatedDate | date: 'dd.MM.yyyy' }}</td>
                        <td class="d-none d-md-table-cell" ng-if="C.User.hasPermission('org.change_org')">
                            <md-button 
                                class='md-icon cus-md-icon-button m-0 w-unset' 
                                ng-if="C.checkIfAssetIsAssigned(asset.assetHistory)" 
                                ng-click='C.returnAsset(asset)'>
                                <md-icon class="md-icon md-primary cus-md-icon-button" md-font-library='material-icons'>
                                    shopping_cart_checkout                    
                                </md-icon>
                            </md-button>
                        </td>
                        <td class="d-none d-md-table-cell" ng-if="C.User.hasPermission('org.change_org')">
                            <md-button 
                                class='md-icon cus-md-icon-button m-0 w-unset' 
                                ng-if="!C.checkIfAssetIsAssigned(asset.assetHistory)" 
                                ng-click='C.assignAsset(asset)'>
                                <md-icon class="md-icon md-primary cus-md-icon-button" md-font-library='material-icons'>
                                    assignment_ind               
                                </md-icon>
                            </md-button>
                        </td>
                        <td class="p-0 d-none d-md-table-cell"><md-button type="button"
                                data-toggle="modal" data-target="#FileEditModal"
                                ng-if="asset.assetHistory.length >0" 
                                ng-click="C.viewAssetHistory(asset.assetHistory)"
                                class="md-icon md-primary cus-md-icon-button"><md-icon
                                    md-font-library="material-icons"
                                    class="p-0">visibility</md-icon></md-button>
                        </td>
                        <td class="p-0 d-none d-md-table-cell" ng-if="C.User.hasPermission('org.change_org')">
                            <md-button type="button"
                                    data-toggle="modal" data-target="#FileEditModal"
                                    ng-click="C.editAsset(asset)"
                                    class="md-icon md-primary cus-md-icon-button"><md-icon
                                        md-font-library="material-icons"
                                        class="p-0">edit</md-icon>
                            </md-button>
                        </td>
                        <td class="d-none d-md-table-cell" ng-if="C.User.hasPermission('org.change_org')">
                            <md-button class='md-icon md-warn cus-md-icon-button m-0 w-unset' ng-click='C.deleteAsset(asset)'>
                                <md-icon class='p-0' md-font-library='material-icons'>
                                    delete_forever                    
                                </md-icon>
                            </md-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        `
    }

    public link($scope: any, $element: any, attrs: any): void {
        const tabSelected = attrs.tab;
        $scope.currentPage=1;
        $scope.numLimit=10;
        $scope.start = 0;
        $scope.typeArray = [];
        $scope.countArray = [];
        $scope.queryType = attrs.tab;
        $scope.index = attrs.index;
        $scope.$watch(() => attrs.val, (n) => {
            if (n !== '') {
                const parseData = JSON.parse(n);
                $scope.typeArray = parseData.filter(data => data);
                $scope.pages=Math.ceil($scope.typeArray.length/$scope.numLimit);
            }
        });
        $scope.assetTable = attrs.asset;

        $scope.hideNext=function(){
            if(($scope.start+ $scope.numLimit) < $scope.typeArray.length){
              return false;
            }
            else 
            return true;
          };
        $scope.hidePrev=function(){
        if($scope.start===0){
            return true;
        }
        else 
        return false;
        };
        $scope.nextPage=function(){
            $scope.currentPage++;
            $scope.start=$scope.start+ $scope.numLimit;
        };
        $scope.PrevPage=function(){
            if($scope.currentPage>1){
                $scope.currentPage--;
              }
              $scope.start=$scope.start - $scope.numLimit;
        }

        if ($scope.value === '---') {
            $scope.value = undefined;
        }

        $scope.change = function (index): any {
            if ($scope.changeFunc !== undefined) {
                var changeObj: any = {
                    new: $scope.typeArray
                };
                $scope.changeFunc({args: changeObj});
            }
            $scope.doneEdit($scope.typeArray[index]);
        };

        // $scope.edit = function (): any {
        //     //$scope.editing = true;
        //     this.currentValue = $scope.value;
        //     // $element.addClass('active');
        //     // $element.addClass('');
        // };

        $scope.doneEdit = function (docObje): any {
            // $scope.editing = false;
            var newValue: any = docObje;
            // $element.removeClass('active');
            var saveObj: any = {
                old: this.currentValue,
                new: newValue,
                model: attrs.value
            };
            if ($scope.saveFunc !== undefined) {
                $scope.saveFunc({args: saveObj});
            }
        };

        $scope.openDocModal = function (docObje): any {
            var newValue: any = docObje;
            // $element.removeClass('active');
            var saveObj: any = {
                old: this.currentValue,
                new: newValue,
                model: attrs.value
            };
            if ($scope.openModal!== undefined) {
                // console.log("open doc modal", docObje);
                $scope.openModal(docObje);
            }
        };

        // $scope.undo = function (): any {
        //     // $element.removeClass('active');
        //     $scope.value = this.currentValue;
        // };
    }



    public static DirectiveFn(
        Process: IProcessService,
        bsLoadingOverlayService: IBsLoadingService
    ): AssetsDirective {
        return new AssetsDirective(Process, bsLoadingOverlayService);
    }

}

AssetsDirective.DirectiveFn.$inject = ['Process', 'bsLoadingOverlayService'];

angular.module('beneple.global').directive('assetsTab', AssetsDirective.DirectiveFn);


// WEBPACK FOOTER //
// ./frontend/scripts/assets/directives/assets.directive.ts